module.exports = __webpack_public_path__ + "static/media/mail.ab3ada02.svg";